export const closeArticleViewer = viewer => ({
  type: "CLOSE_ARTICLE_VIEWER",
  viewer
});

export const openArticleViewer = viewer => ({
  type: "OPEN_ARTICLE_VIEWER",
  viewer
});

export const setCurrentArticle = media => ({
  type: "SET_CURRENT_ARTICLE_VIEWER",
  media: media
});

export const fetchSingleArticle = resp => {
  return {
    type: "FETCH_SINGLE_ARTICLE",
    payload: resp
  };
};



// WEBPACK FOOTER //
// ./src/actions/actions/article-viewer.js